<template>
  <div>
    <el-dialog :visible.sync="visible" title="使用员工" custom-class="my-dialog-template use-staff-dialog" width="800px" :close-on-click-modal="false">
      <div class="btn-wrap">
        <el-button type="primary" size="small" @click="batchAdd">批量添加</el-button>
      </div>
      <el-table style="width: 100%" :data="tableData" border class="list-table" v-loading="listLoading" tooltip-effect="dark">
        <el-table-column prop="" type="index" width="80" label="序号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" min-width="150px;" label="员工姓名" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mobile" min-width="120px;" label="手机号码" show-overflow-tooltip></el-table-column>
        <el-table-column property="useStatus" min-width="100" label="状态" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="green-tag" v-if="scope.row.useStatus == '1'" type="success">已开通</span>
            <span class="red-tag" v-if="scope.row.useStatus == '0'" type="gray">已禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" min-width="180px;" label="入驻时间" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createTime | timeSubstr(0, 10) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="tableData.length > 0"
        class="page"
        @size-change="
          pageNum = 1;
          pageSize = $event;
          getList();
        "
        :pager-count="5"
        :current-page.sync="pageNum"
        :page-size.sync="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="getList()"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
      >
      </el-pagination>
    </el-dialog>
    <addUser ref="addUser" @reload="getList"></addUser>
  </div>
</template>
<script>
import { pageTool } from '@/api/mixins'
import addUser from './addUser'
export default {
  mixins: [pageTool],
  data: () => ({
    visible: false,
    productTemplateCode: '',
    mechanId: '',
    name: ''
  }),
  components: {
    addUser
  },
  created() {
  },
  methods: {
    batchAdd() {
      this.$refs.addUser.open({ productTemplateCode: this.productTemplateCode, mechanId: this.mechanId, name: this.name })
    },
    open({ productTemplateCode, mechanId, name }) {
      console.log(productTemplateCode, mechanId)
      this.productTemplateCode = ''
      this.visible = true
      this.productTemplateCode = productTemplateCode
      this.name = name
      this.mechanId = mechanId
      this.initListAjax('/master/subAccount/queryMechanSubAccount')
    },
    // 设置自定义参数
    setListParams(params) {
      params.productTemplateCode = this.productTemplateCode
    },
  }
}
</script>
<style lang='scss'>
.btn-wrap {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.use-staff-dialog {
  .list-table {
    margin-bottom: 30px;
    .el-table__row {
      height: 50px;
    }
    .cell {
      line-height: 25px;
    }
    .green-tag {
      width: 60px;
      height: 24px;
      background: #f6ffec;
      border: 1px solid #b7ea8f;
      border-radius: 4px;
      padding: 2px 9px;
      color: #22bc02;
    }
    .red-tag {
      width: 60px;
      height: 24px;
      background: #fff1f0;
      border: 1px solid #fda39e;
      border-radius: 4px;
      padding: 2px 9px;
      color: #f8585d;
    }
    .el-table__body-wrapper {
      max-height: 325px;
      overflow-y: scroll;
    }
  }
  .dialog-footer {
    margin-top: 30px;
  }
}
</style>